import { render, staticRenderFns } from "./TaxiTransactionList.vue?vue&type=template&id=23f5d738&scoped=true"
import script from "./TaxiTransactionList.vue?vue&type=script&lang=js"
export * from "./TaxiTransactionList.vue?vue&type=script&lang=js"
import style0 from "./TaxiTransactionList.vue?vue&type=style&index=0&id=23f5d738&prod&lang=scss&scoped=true"
import style1 from "./TaxiTransactionList.vue?vue&type=style&index=1&id=23f5d738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5d738",
  null
  
)

export default component.exports